import { createAsyncThunk } from "@reduxjs/toolkit";
import { AllProperty, FilterState } from "./slice";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";


interface AreaListResponse {
  filterData: FilterState;
  success: boolean;
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  data: AllProperty[];
}

interface FetchAreaListParams {
  page?: number;
  limit?: number;
  state?: string;
  city?: string;
  area?: string,
  search?: string;
  sortBy?: string | null;
  sortOrder?: "asc" | "desc" | null;
}
export const fetchAllProperties = createAsyncThunk<AreaListResponse, any>(
  "allProperties/fetch",
  async (
    {
      page = 1,
      limit = 10,
      state = "",
      city = "",
      area = "",
      search = "",
      sortBy = null,
      sortOrder = null,
    },
    thunkAPI
  ) => {
    try {
      const params = {
        page,
        limit,
        state: state || undefined,
        city: city || undefined,
        area: area || undefined,
        search: search || undefined,
        sortBy: sortBy || undefined,
        sortOrder: sortOrder || undefined,
      };

      const response = await apiGet(endPoints.GET_ALL_PROPERTIES, params);

      return {
        data: response.data,
        filterData: {
          state,
          city,
          area,
          search,
          page: response.page,
          limit: response.limit,
          totalCount: response.total,
          sortBy,
          sortOrder,
        },
        success: response.success,
        page: response.page,
        limit: response.limit,
        total: response.total,
        totalPages: response.totalPages,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch all properties list");
    }
  }
);

